import { FormControl, FormHelperText } from "@mui/material";
import React, { useEffect, useState } from "react";
import MaterialInput from "../../../../../../components/MaterialInput";
import MaterialTypography from "../../../../../../components/MaterialTypography";
import MaterialBox from "../../../../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import MaterialSelect from "../../../../../../components/MasterSelect";
import countryCode from "./Countrycode";
import { useUserDetails } from "../../../../../../context/auth";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Country, State, City } from "country-state-city";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
const PersonalInformation = ({
  employeeData,
  handleEmployeeDataChange,
  resources,
  togglePage,
  handleEmployee,
}) => {
  const { validation, validationMessages } = useUserDetails();
  const [phoneCodes] = useState(countryCode); // Used to get phoneCodes datas from API
  console.log("Rendered:", Country.getAllCountries());

  return (
    <Grid container spacing={1}>
      <Grid size={{ xs: 5, sm: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            First Name <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <MaterialInput
          name="firstName"
          // placeholder="eg. Ajith"
          value={employeeData.firstName}
          onChange={handleEmployeeDataChange}
          error={employeeData.firstNameStatus === "error" ? true : false}
          success={employeeData.firstNameStatus === "success" ? true : false}
          disabled={togglePage.view === true ? true : false}
          inputProps={{
            style: { backgroundColor: "transparent" }, // or your desired color
          }}
        />
        {employeeData.firstNameStatus === "error" && (
          <FormControl error>
            <FormHelperText>
              First Name should be maximum 20 characters long and can contain
              only alphabets
            </FormHelperText>
          </FormControl>
        )}
        {validationMessages.firstName && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.firstName}
          </label>
        )}
      </Grid>
      <Grid size={{ xs: 5, sm: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Last Name <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <MaterialInput
          name="lastName"
          // placeholder="eg. Kumar"
          value={employeeData.lastName}
          onChange={handleEmployeeDataChange}
          error={employeeData.lastNameStatus === "error" ? true : false}
          success={employeeData.lastNameStatus === "success" ? true : false}
          disabled={togglePage.view === true ? true : false}
        />
        {employeeData.lastNameStatus === "error" && (
          <FormControl error>
            <FormHelperText>
              Last Name should be maximum 20 characters long and can contain
              only alphabets
            </FormHelperText>
          </FormControl>
        )}
        {validationMessages.lastName && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.lastName}
          </label>
        )}
      </Grid>
      <Grid size={{ xs: 5, sm: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Father Name
          </MaterialTypography>
        </MaterialBox>
        <MaterialInput
          name="fathername"
          // placeholder="eg. Raja"
          value={employeeData.fathername}
          onChange={handleEmployeeDataChange}
          error={employeeData.fathernameStatus === "error" ? true : false}
          success={employeeData.fathernameStatus === "success" ? true : false}
          disabled={togglePage.view === true ? true : false}
        />
        {employeeData.fathernameStatus === "error" && (
          <FormControl error>
            <FormHelperText>
              Last Name should be maximum 20 characters long and can contain
              only alphabets
            </FormHelperText>
          </FormControl>
        )}
      </Grid>

      {/* <Grid size={{ xs: 12, sm: 4, lg: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            User Name
          </MaterialTypography>
        </MaterialBox>
        <MaterialInput
          name="userName"
          // placeholder="eg: Ajithkumar"
          value={employeeData.userName}
          onChange={handleEmployeeDataChange}
          error={employeeData.userNameStatus === "error" ? true : false}
          success={employeeData.userNameStatus === "success" ? true : false}
          disabled={togglePage.view === true ? true : false}
        />
        {employeeData.userNameStatus === "error" && (
          <FormControl error>
            <FormHelperText>
              User Name should be maximum 20 characters long.
            </FormHelperText>
          </FormControl>
        )}
      </Grid> */}
      <Grid size={{ xs: 5, sm: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            DOB <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <MaterialInput
          name="dob"
          type="date"
          value={employeeData.dob}
          onChange={handleEmployeeDataChange}
          error={employeeData.dobStatus === "error" ? true : false}
          success={employeeData.dobStatus === "success" ? true : false}
          disabled={togglePage.view === true ? true : false}
          inputProps={{
            max: new Date().toISOString().split("T")[0],
          }}
        />
        {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={["DatePicker"]}>
        <DatePicker
          sx={{
            "& .MuiInputBase-root": {
              fontSize: "0.8rem", // Smaller text
              height: "2.5rem", // Smaller height
            },
            "& .MuiOutlinedInput-root": {
              padding: "0 8px", // Adjust padding
            },
          }}
        />
      </DemoContainer>
    </LocalizationProvider> */}
        {employeeData.dobStatus === "error" && (
          <FormControl error>
            <FormHelperText>Please enter a valid DOB</FormHelperText>
          </FormControl>
        )}
      </Grid>
      <Grid size={{ xs: 5, sm: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Email Id <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <MaterialInput
          name="email"
          // placeholder="eg: ajithkumar@gmail.com"
          value={employeeData.email}
          onChange={handleEmployeeDataChange}
          error={employeeData.emailStatus === "error" ? true : false}
          success={employeeData.emailStatus === "success" ? true : false}
          disabled={togglePage.view === true ? true : false}
        />
        {employeeData.emailStatus === "error" && (
          <FormControl error>
            <FormHelperText>Please enter a valid email address</FormHelperText>
          </FormControl>
        )}
        {validationMessages.email && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.email}
          </label>
        )}
      </Grid>
      <Grid size={{ xs: 5, sm: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Gender <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <MaterialSelect
          name="gender"
          value={employeeData.gender}
          customStyles={{ optionPadding: 20 }}
          onChange={handleEmployeeDataChange} //selectedValue, event
          options={resources.gender.map((value) => {
            return {
              value: value.value,
              label: value.label,
            };
          })}
          error={employeeData.genderStatus === "error" ? true : false}
          success={employeeData.genderStatus === "success" ? true : false}
          isDisabled={togglePage.view === true ? true : false}
          // isClearable
        />
        {validationMessages.gender && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.gender}
          </label>
        )}
      </Grid>
      <Grid size={{ xs: 5, sm: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Marital Status <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <MaterialSelect
          name="martialstatus"
          value={employeeData.martialstatus}
          customStyles={{ optionPadding: 20 }}
          onChange={handleEmployeeDataChange} 
          options={resources.martialstatus.map((value) => {
            return {
              value: value.value,
              label: value.label,
            };
          })}
          error={employeeData.martialstatusStatus === "error" ? true : false}
          success={employeeData.martialstatusStatus === "success" ? true : false}
          isDisabled={togglePage.view === true ? true : false}
          // isClearable
        />
        {validationMessages.maritalStatus && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.maritalStatus}
          </label>
        )}
      </Grid>

      <Grid size={{ xs: 5, sm: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Address <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <MaterialInput
          name="address"
          multiline
          rows={3}
          // placeholder="eg. Kumar"
          value={employeeData.address}
          onChange={handleEmployeeDataChange}
          disabled={togglePage.view === true ? true : false}
          error={employeeData.addressStatus === "error" ? true : false}
          success={employeeData.addressStatus === "success" ? true : false}
        />
        {employeeData.addressStatus === "error" && (
          <FormControl error>
            <FormHelperText>
              Address should be maximum 50 characters long and can contain only
              alphabets
            </FormHelperText>
          </FormControl>
        )}
        {validationMessages.address && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.address}
          </label>
        )}
      </Grid>

      <Grid size={{ xs: 5, sm: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Country <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <MaterialSelect
          name="country"
          value={employeeData.country}
          customStyles={{ optionPadding: 20 }}
          onChange={handleEmployeeDataChange} //selectedValue, event
          options={Country.getAllCountries().map((value) => {
            return {
              value: value.name,
              label: value.name,
              isoCode: value.isoCode,
              phonecode: value.phonecode,
            };
          })}
          error={employeeData.countryStatus === "error" ? true : false}
          success={employeeData.countryStatus === "success" ? true : false}
          isDisabled={togglePage.view === true ? true : false}
          // isClearable
        />
        {validationMessages.country && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.country}
          </label>
        )}
      </Grid>

      <Grid size={{ xs: 5, sm: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            State <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <MaterialSelect
          name="state"
          value={employeeData.state}
          customStyles={{ optionPadding: 20 }}
          onChange={handleEmployeeDataChange} //selectedValue, event
          options={State.getStatesOfCountry(employeeData.country?.isoCode).map(
            (value) => {
              return {
                value: value.name,
                label: value.name,
                isoCode: value.isoCode,
                countryCode: value.countryCode,
              };
            }
          )}
          error={employeeData.stateStatus === "error" ? true : false}
          success={employeeData.stateStatus === "success" ? true : false}
          isDisabled={togglePage.view === true ? true : false}
          // isClearable
        />
        {validationMessages.state && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.state}
          </label>
        )}
      </Grid>
      <Grid size={{ xs: 5, sm: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            City <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <MaterialSelect
          name="city"
          value={employeeData.city}
          customStyles={{ optionPadding: 20 }}
          onChange={handleEmployeeDataChange} //selectedValue, event'
          options={City.getCitiesOfState(
            employeeData.state?.countryCode || "",
            employeeData.state?.isoCode
          ).map((value) => {
            return {
              value: value.name,
              label: value.name,
            };
          })}
          error={employeeData.cityStatus === "error" ? true : false}
          success={employeeData.cityStatus === "success" ? true : false}
          isDisabled={togglePage.view === true ? true : false}
          // isClearable
        />
        {validationMessages.city && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.city}
          </label>
        )}
      </Grid>
      <Grid size={{ xs: 5, sm: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Zip Code <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <MaterialInput
          name="zipcode"
          // placeholder="eg. 123456"
          value={employeeData.zipcode}
          onChange={handleEmployeeDataChange}
          error={employeeData.zipcodeStatus === "error"}
          success={employeeData.zipcodeStatus === "success"}
          disabled={togglePage.view === true ? true : false}
        />
        {employeeData.zipcodeStatus === "error" && (
          <FormControl error>
            <FormHelperText>
            Zip Code should be 5 to 8 characters long and contain only letters and numbers.
            </FormHelperText>
          </FormControl>
        )}
        {validationMessages.zipcode && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.zipcode}
          </label>
        )}
      </Grid>

      {/* <Grid size={{ xs: 4, sm: 2, lg: 2 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Country code <span style={{color:"red"}}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <MaterialSelect
          name="countryCode"
          value={employeeData.countryCode}
          customStyles={{ optionPadding: 20 }}
          onChange={handleEmployeeDataChange} //selectedValue, event
          options={phoneCodes.map((option) => {
            return {
              value: option.code,
              label: `+${option.phone}`,
            };
          })}
          menuPortalTarget={document.body}
          menuPosition={"fixed"}
          error={employeeData.countryCodeStatus === "error" ? true : false}
          success={employeeData.countryCodeStatus === "success" ? true : false}
          isDisabled={togglePage.view === true ? true : false}

        />
         {validationMessages.countryCode && (
    <label style={{ color: "red", fontSize: "12px" }}>
      {validationMessages.countryCode}
    </label>
  )}
      </Grid> */}
      <Grid size={{ xs: 5, md:6,lg:4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Contact Number <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        {/* <MaterialInput
          name="contactNumber"
          placeholder="eg: 7865344543"
          value={employeeData.contactNumber}
          onChange={handleEmployeeDataChange}
          disabled={togglePage.view === true ? true : false}
          error={employeeData.contactNumberStatus === "error" ? true : false}
          success={
            employeeData.contactNumberStatus === "success" ? true : false
          }
        /> */}
        <PhoneInput
         
        
          country={
            employeeData.country
              ? employeeData.country?.isoCode?.toLowerCase()
              : "in"
          }
          value={`+${employeeData.contactNumber}`}
          onChange={(value) => handleEmployee(value, "contactNumber",employeeData.country?.phonecode)}
          name="contactNumber"
          disabled={togglePage.view}
          countryCodeEditable	={false}
          disableDropdown = {false}
          inputProps={{
            required: true,
            style: {
              borderRadius: "8px",
              border: "0.0625rem solid #d2d6da",
              height: "40px",
              paddingLeft: "48px", // Ensure proper padding for flag
              borderColor:
                employeeData.contactNumberStatus === "error" ? "red" : "#ccc",
            },
          }}
          containerStyle={{
            borderRadius: "8px",
            width: "100%",
          }}
          buttonStyle={{
            border: "none",
            backgroundColor: "transparent",
            borderRadius: "8px 0 0 8px",
          }}
          inputStyle={{
            borderRadius: "0 8px 8px 0",
            fontSize: "14px",
          }}
        />

        {employeeData.contactNumberStatus === "error" && (
          <FormControl error>
            <FormHelperText>
              Contact number is mandatory.
            </FormHelperText>
          </FormControl>
        )}
        
        {validationMessages.contactNumber && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.contactNumber}
          </label>
        )}
      </Grid>
      {/* <Grid size={{ xs: 4, sm: 2, lg: 2 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Country code 
          </MaterialTypography>
        </MaterialBox>
        <MaterialSelect
          name="countryCode"
          value={employeeData.countryCode}
          customStyles={{ optionPadding: 20 }}
          onChange={handleEmployeeDataChange} //selectedValue, event
          options={phoneCodes.map((option) => {
            return {
              value: option.code,
              label: `+${option.phone}`,
            };
          })}
          menuPortalTarget={document.body}
          menuPosition={"fixed"}
          isDisabled={togglePage.view === true ? true : false}
          error={employeeData.countryCodeStatus === "error" ? true : false}
          success={employeeData.countryCodeStatus === "success" ? true : false}
        />
        
      </Grid> */}
      <Grid size={{ xs: 5, sm: 4}}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Emergency Number
          </MaterialTypography>
        </MaterialBox>
        {/* <MaterialInput
          name="emergencyNumber"
          placeholder="eg: 7865344543"
          value={employeeData.emergencyNumber}
          onChange={handleEmployeeDataChange}
          disabled={togglePage.view === true ? true : false}
          error={employeeData.emergencyNumberStatus === "error" ? true : false}
          success={
            employeeData.emergencyNumberStatus === "success" ? true : false
          }
        /> */}
        <PhoneInput
          country={
            employeeData.country
              ? employeeData.country?.isoCode?.toLowerCase()
              : "in"
          }
          value={`+${employeeData?.emergencyNumber}`}
          onChange={(value) => handleEmployee(value, "emergencyNumber",employeeData.country?.phonecode)}
          countryCodeEditable	={false}
          name="emergencyNumber"
          disabled={togglePage.view}
          inputProps={{
            required: true,
            style: {
              borderRadius: "8px",
              height: "40px",
              paddingLeft: "48px", // Ensure proper padding for flag
              borderColor:
                employeeData.emergencyNumberStatus === "error" ? "red" : "#ccc",
            },
          }}
          containerStyle={{
            borderRadius: "8px",
            width: "100%",
          }}
          buttonStyle={{
            border: "none",
            backgroundColor: "transparent",
            borderRadius: "8px 0 0 8px",
          }}
          inputStyle={{
            borderRadius: "0 8px 8px 0",
            fontSize: "14px",
          }}
        />

        {employeeData.emergencyNumberStatus === "error" && (
          <FormControl error>
            <FormHelperText>
              Emergeny number is mandatory.
            </FormHelperText>
          </FormControl>
        )}
      </Grid>

      <Grid size={{ xs: 5, sm: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Aadhar Number <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <MaterialInput
          name="aadharnumber"
          placeholder="eg: 4606 9848 5156"
          value={employeeData.aadharnumber}
          onChange={handleEmployeeDataChange}
          error={employeeData.aadharnumberStatus === "error"}
          success={employeeData.aadharnumberStatus === "success"}
          disabled={togglePage.view === true ? true : false}
        />
        {employeeData.aadharnumberStatus === "error" && (
          <FormControl error>
            <FormHelperText>
              Aadhar Number should be exactly 12 digits long and in the format
              "xxxxxxxxxxxx".
            </FormHelperText>
          </FormControl>
        )}
        {validationMessages.aadharNumber && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.aadharNumber}
          </label>
        )}
      </Grid>
      <Grid size={{ xs: 5, sm: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            PAN Number <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <MaterialInput
          name="pannumber"
          placeholder="eg: ABCDE1234F"
          value={employeeData.pannumber}
          onChange={handleEmployeeDataChange}
          error={employeeData.pannumberStatus === "error"}
          success={employeeData.pannumberStatus === "success"}
          disabled={togglePage.view === true ? true : false}
        />
        {employeeData.pannumberStatus === "error" && (
          <FormControl error>
            <FormHelperText>
              PAN Number should be in the format "ABCDE1234F" (5 letters, 4
              digits, and 1 letter).
            </FormHelperText>
          </FormControl>
        )}
        {validationMessages.panNumber && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.panNumber}
          </label>
        )}
      </Grid>
    </Grid>
  );
};

export default PersonalInformation;
